/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { productMovementPayload } from '../models/productMovementPayload';
import type { salesPayload } from '../models/salesPayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TransactionService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create a sales transaction
     * @returns any Sales Transaction created successfully
     * @throws ApiError
     */
    public postTransactionSales({
        requestBody,
    }: {
        requestBody: salesPayload,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/transaction/sales',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a stock transaction and movement
     * @returns any Stock Transaction created successfully
     * @throws ApiError
     */
    public postTransactionStock({
        requestBody,
    }: {
        requestBody: productMovementPayload,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/transaction/stock',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a stock transaction and movement
     * @returns any Stock Transaction created successfully
     * @throws ApiError
     */
    public postTransactionIncoming({
        requestBody,
    }: {
        requestBody: productMovementPayload,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/transaction/incoming',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a stock transaction and movement
     * @returns any Stock Transaction created successfully
     * @throws ApiError
     */
    public postTransactionOutgoing({
        requestBody,
    }: {
        requestBody: productMovementPayload,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/transaction/outgoing',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get next identifier
     * @returns string Next Identifier of store by user login
     * @throws ApiError
     */
    public getTransactionStoreIdentifier(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/store/identifier',
            errors: {
                404: `Identifier not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get transfer detail
     * @returns any The sales data
     * @throws ApiError
     */
    public getTransactionTransfer({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/transaction/transfer/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Sales not found`,
                500: `Internal server error`,
            },
        });
    }

}
